import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-standing__top as-row-name"
}
const _hoisted_2 = { class: "as-standing__top" }
const _hoisted_3 = { class: "as-standing__table" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "as-has-arrow-right"
}
const _hoisted_6 = { class: "as-has-arrow-right-info" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "as-stt" }
const _hoisted_9 = { class: "as-match__team" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "as-standing__table-text" }
const _hoisted_12 = {
  key: 0,
  class: "as-standing__table-column as-text-center"
}
const _hoisted_13 = { class: "as-standing__table-column as-text-center" }
const _hoisted_14 = { class: "as-standing__table-column as-text-center" }
const _hoisted_15 = { class: "as-standing__table-column as-text-center" }
const _hoisted_16 = { class: "as-standing__table-column as-text-center" }
const _hoisted_17 = { class: "as-standing__table-column as-text-center as-coulumn-show-full" }
const _hoisted_18 = {
  key: 1,
  class: "as-standing__table-column as-text-center as-coulumn-show-full"
}
const _hoisted_19 = {
  key: 2,
  class: "as-standing__table-column as-text-center as-coulumn-show-full"
}
const _hoisted_20 = {
  key: 3,
  class: "as-standing__table-column as-text-center as-coulumn-show-full"
}
const _hoisted_21 = {
  key: 4,
  class: "as-standing__table-column as-text-center as-coulumn-show-full"
}
const _hoisted_22 = {
  key: 5,
  class: "as-standing__table-column as-text-center as-coulumn-show-full"
}
const _hoisted_23 = {
  key: 6,
  class: "as-standing__table-column as-text-center as-coulumn-show-full"
}
const _hoisted_24 = {
  key: 7,
  class: "as-standing__table-column as-text-center as-coulumn-show-full"
}
const _hoisted_25 = { class: "as-standing__table-column as-text-center as-coulumn-show-full" }
const _hoisted_26 = { class: "as-standing-tag__list" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "as-standing__table-column as-text-center as-coulumn-show-full" }
const _hoisted_29 = ["src", "alt"]

import { ref, computed, nextTick, onMounted, getCurrentInstance } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import IconArrowRight from "~src/components/icons/IconArrowRight.vue";
import type {
  IStanding,
  IMatch,
  ITeam,
  IStandingsRow,
  IStandingsTable,
  IPromotion,
  IRecent,
} from "~src/interfaces//basketball";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  determineMatchResult,
  getTeamName,
} from "~src/helpers/basketball/index";
import MatchEnum from "~src/enums/MatchEnum";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  standing: IStanding;
  match?: IMatch;
  isPopup: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StandingListTab',
  props: {
    standing: {},
    match: {},
    isPopup: { type: Boolean, default: true }
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const isShowFull = ref(false);
const activeTab = ref("all");
const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: "Sân nhà",
    key: "home",
  },
  {
    title: "Sân khách",
    key: "away",
  },
]);

const columnsCup = [
  {
    title: "#",
    name: "position",
    class: "as-text-center as-standing__table-column-stt as-column-head",
  },
  {
    title: "Đội bóng",
    name: "team_name",
    class: "as-standing__table-column-team as-column-head",
  },
  {
    title: "W",
    name: "won",
    class: "as-text-center as-c-w",
  },
  {
    title: "L",
    name: "lost",
    class: "as-text-center as-c-l",
  },
  {
    title: "WIN%",
    name: "pct",
    class: "as-text-center as-c-strk",
  },
  {
    title: "STR",
    name: "strk",
    class: "as-text-center as-c-strk",
  },
  {
    title: "GB",
    name: "game_back",
    class: "as-text-center as-c-g as-coulumn-show-full",
  },
  {
    title: "HOME",
    name: "home",
    class: "as-text-center as-c-home as-coulumn-show-full",
  },
  {
    title: "AWAY",
    name: "away",
    class: "as-text-center as-c-away as-coulumn-show-full",
  },
  {
    title: "DIV",
    name: "div",
    class: "as-text-center as-c-div as-coulumn-show-full",
  },
  {
    title: "CONF",
    name: "conf",
    class: "as-text-center as-c-conf as-coulumn-show-full",
  },
  {
    title: "PPG",
    name: "ppg",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "OPP",
    name: "opp",
    class: "as-text-center as-coulumn-show-full",
  },
  // {
  //   title: "PPG",
  //   name: "ppg",
  //   class: "as-text-center as-coulumn-show-full",
  // },
  {
    title: "DIFF",
    name: "diff",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "Phong độ",
    name: "points1",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "Tiếp",
    name: "next",
    class:
      "as-text-center as-scroll-item-active as-column-next as-coulumn-show-full",
  },
];
const columnsLeague = [
  {
    title: "#",
    name: "position",
    class: "as-text-center as-standing__table-column-stt as-column-head",
  },
  {
    title: "Đội bóng",
    name: "team_name",
    class: "as-standing__table-column-team as-column-head",
  },
  {
    title: "P",
    name: "p",
    class: "as-text-center as-c-p",
  },
  {
    title: "W",
    name: "won",
    class: "as-text-center as-c-w",
  },
  {
    title: "L",
    name: "lost",
    class: "as-text-center as-c-l",
  },
  {
    title: "PCT%",
    name: "pct",
    class: "as-text-center as-c-strk",
  },
  {
    title: "STR",
    name: "strk",
    class: "as-text-center as-c-pts",
  },
  {
    title: "GB",
    name: "game_back",
    class: "as-text-center as-c-pts as-coulumn-show-full",
  },
  {
    title: "Phong độ",
    name: "points1",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "Tiếp",
    name: "next",
    class:
      "as-text-center as-scroll-item-active as-column-next as-coulumn-show-full",
  },
];

let isLeague =
  props?.match?.competition?.type == MatchEnum.STAGE_MODE_LEAGUE ? true : false;

// default league
isLeague = true;
const columns = isLeague ? columnsLeague : columnsCup;

const sort = ref({
  column: "",
  type: "ASC",
});

const activeTitle = ref("");
const changeTitles = (val: string) => {
  activeTitle.value = val;
};

const rowsTitles = computed(() => {
  if (!props?.standing?.standings) {
    return [];
  }

  const { kind } = props.standing.match;
  const _rowsTitles: any = [];
  if (kind === 1) {
    // Regular season
    props.standing.standings.map((item: any) => {
      if (item.scope === 5) {
        _rowsTitles.push({
          key: item.id,
          title: item.name,
        });
      }
    });
  }

  if (kind === 2) {
    // Playoffs
    props.standing.standings.map((item: any) => {
      if (item.scope === 6) {
        _rowsTitles.push({
          key: item.id,
          title: item.name,
        });
      }
    });
  }

  if (kind === 3) {
    // Preseason
    props.standing.standings.map((item: any) => {
      if (item.scope === 4) {
        _rowsTitles.push({
          key: item.id,
          title: item.name,
        });
      }
    });
  }

  return _rowsTitles;
});

const rowsConverted = computed(() => {
  if (!props?.standing?.standings) {
    return [];
  }
  const standingJson: any = [];
  let __standings: any[] = props.standing.standings;
  if (activeTitle.value) {
    __standings = __standings.filter(
      (item: any) => item.id === activeTitle.value
    );
  }
  const instance: any = getCurrentInstance();
  __standings.map((item: any) => {
    const rows = [];
    for (const row of item.rows) {
      const _won = Number(row.won || 0);
      const _lost = Number(row.lost || 0);
      const _p = _won + _lost;
      const _pct = _p ? (Number(_won / _p || 0) * 100).toFixed(1) || "0" : 0;
      rows.push({
        ...row,
        team_name: getTeamName(props.standing.teams, row.team_id),
        next:
          row?.next_match?.home_team?.id === row.team_id
            ?  instance.proxy?.getImgUrlBySport("team", row?.next_match?.away_team?.id)
            :  instance.proxy?.getImgUrlBySport("team", row?.next_match?.home_team?.id),
        won: _won,
        lost: _lost,
        p: _p,
        pct: _pct,
        pts: row.points || 0,
      });
    }

    rows?.sort((a: any, b: any) => {
      if (activeTab.value === "all") {
        // chọn sắp xếp
        if (sort.value.column) {
          // sắp xếp string
          if (sort.value.column === "team_name") {
            if (sort.value.type === "DESC") {
              return a.team_name.localeCompare(b.team_name);
            } else {
              return b.team_name.localeCompare(a.team_name);
            }
          } else {
            if (sort.value.type === "DESC") {
              return a[sort.value.column] - b[sort.value.column];
            } else {
              return b[sort.value.column] - a[sort.value.column];
            }
          }
        } else {
          return a.position - b.position;
        }
      } else {
        if (sort.value.column) {
          if (sort.value.column === "team_name") {
            if (sort.value.type === "DESC") {
              return a.team_name.localeCompare(b.team_name);
            } else {
              return b.team_name.localeCompare(a.team_name);
            }
          } else {
            if (sort.value.type === "DESC") {
              return (
                a[`${activeTab.value}_${sort.value.column}`] -
                b[`${activeTab.value}_${sort.value.column}`]
              );
            } else {
              return (
                b[`${activeTab.value}_${sort.value.column}`] -
                a[`${activeTab.value}_${sort.value.column}`]
              );
            }
          }
        } else {
          return (
            a[`${activeTab.value}_position`] - b[`${activeTab.value}_position`]
          );
        }
      }
    });
    standingJson.push({
      id: item.id,
      name: item.name,
      scope: item.scope,
      rows: rows,
    });
  });

  if (standingJson.length > 1) {
    const { home_team_id, away_team_id } = props.standing.match;
    const result = standingJson.filter((arr: any) => {
      const isIncludeHomeTeam = arr.rows.some(
        (row: any) => row.team_id === home_team_id
      );
      const isIncludeAwayTeam = arr.rows.some(
        (row: any) => row.team_id === away_team_id
      );
      if (isIncludeHomeTeam && isIncludeAwayTeam) {
        return arr;
      }
    });
    const { kind } = props.standing.match;
    if (result.length > 1) {
      const currentSeason = result.filter((arr: any) => {
        // Statistics range，1-season，2-qualifier，3-group stage，4-preseason，5-regular season，6-elimination (playoffs)
        // Type id，1-Regular season，2-Playoffs，3-Preseason，4-All-Star，5-Cup，6-play offs，0-None
        if (kind === 1) {
          return arr.scope === 5;
        }
        if (kind === 2) {
          return arr.scope === 6;
        }
        if (kind === 3) {
          return arr.scope === 4;
        }
      });
      if (currentSeason.length === 0) {
        return result.map((item: any) => {
          return item.rows;
        });
      }
      return currentSeason.map((item: any) => {
        return item.rows;
      });
    }

    if (result.length === 0) {
      let data = standingJson.filter((item: any) => {
        if (kind === 1) {
          return item.scope === 5;
        }
        if (kind === 2) {
          return item.scope === 6;
        }
        if (kind === 3) {
          return item.scope === 4;
        }
      });
      if (data.length === 0) {
        return standingJson.map((item: any) => {
          return item.rows;
        });
      }
      if (data.length <= 2) {
        // two team in two different standing
        data = data.map((i: any) => i.rows);
        return data;
      }
      const result = standingJson.filter((arr: any) => {
        const isIncludeHomeTeam = arr.rows.some(
          (row: any) => row.team_id === home_team_id
        );
        const isIncludeAwayTeam = arr.rows.some(
          (row: any) => row.team_id === away_team_id
        );
        if (isIncludeHomeTeam || isIncludeAwayTeam) {
          return arr;
        }
      });
      if (result.length !== 0) {
        return result.map((item: any) => {
          return item.rows;
        });
      }
      data = data.map((i: any) => i.rows);
      return data;
    }

    return result.map((item: any) => {
      return item.rows;
    });
  }
  const _standings = standingJson.map((item: any) => {
    return item.rows;
  });

  return _standings;
});

const changeTab = (val: string) => {
  activeTab.value = val;
};

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getRowdata = (row: IStandingsRow, field: string) => {
  if (field === "won") {
    return row.won || 0;
  } else if (field === "lost") {
    return row.lost || 0;
  } else if (field === "game_back") {
    return row.game_back == "-" ? "0.0" : row.game_back;
  } else if (field === "home") {
    return row.home || "0-0";
  } else if (field === "away") {
    return row.away || "0-0";
  } else if (field === "div") {
    return row.division || "0-0";
  } else if (field === "conf") {
    return row.conference || "0-0";
  } else if (field === "ppg") {
    return row.points_avg || "0";
  } else if (field === "opp") {
    return row.points_agt || "0";
  } else if (field === "diff") {
    return row.diff_avg || "0";
  } else if (field === "strk") {
    if (row.streaks && parseInt(row.streaks?.toString()) > 0) {
      return `T${row.streaks}`;
    } else if (row.streaks && parseInt(row.streaks?.toString()) < 0) {
      return `B${Math.abs(parseInt(row.streaks?.toString()))}`;
    } else {
      return "0";
    }
  } else if (field === "pct") {
    return (Number(row.won_rate || 0) * 100).toFixed(1) || "0";
  } else if (field === "next") {
    return row.next || "";
  }
};

const getRecentTitle = (recent: IRecent) => {
  return `${recent.home_scores[0]}:${recent.away_scores[0]} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const activeItems = ref<HTMLDivElement | null>(null);
const standingRef = ref<HTMLDivElement | null>(null);

const scrollToActiveItem = (container: HTMLDivElement, activeItem: HTMLDivElement) => {
  try {
    if (!container || !activeItem) return;

    const containerRect = container.getBoundingClientRect();
    const activeItemRect = activeItem.getBoundingClientRect();

    const scrollLeft = container.scrollLeft + activeItemRect.left - containerRect.left;

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  } catch (error) {
    console.error('Error in scrollToActiveItem:', error);
  }
}

const handleShowFull = async () => {
  isShowFull.value = !isShowFull.value;
  await nextTick();

  if (!standingRef.value || !isShowFull.value) return;

  const _tables = standingRef.value.querySelectorAll<HTMLDivElement>(".as-standing__table") ?? [];
  if (!_tables?.length) return;

  Array.from(_tables).forEach((table) => {
    try {
      const activeItem = table.querySelector<HTMLDivElement>(".as-scroll-item-active");
      if (!activeItem) return;
    
      requestAnimationFrame(() => {
        setTimeout(() => {
          scrollToActiveItem(table, activeItem);
        }, 100);
      });
    } catch (error) {
      console.error('Error scrolling to active item:', error);
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (rowsConverted.value.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`as-parent-standing as-parent-standing-${siteName.value}`),
        ref_key: "standingRef",
        ref: standingRef
      }, [
        (rowsTitles.value[0]?.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(TabsBtn, {
                tabs: rowsTitles.value,
                activeTab: activeTitle.value,
                onChange: changeTitles
              }, null, 8, ["tabs", "activeTab"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TabsBtn, {
            tabs: tabs.value,
            activeTab: activeTab.value,
            onChange: changeTab
          }, null, 8, ["tabs", "activeTab"]),
          _createElementVNode("div", {
            class: _normalizeClass(["as-menu", {
          'as-active': isShowFull.value,
        }]),
            onClick: handleShowFull
          }, [
            _createVNode(IconMenu)
          ], 2)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowsConverted.value, (rows, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["as-standing", {
        'as-show-full': isShowFull.value,
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup':
          _ctx.isPopup,
      }]),
            key: key
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass([
            'as-standing__table-row',
            _unref(isLeague) ? 'as-row__league' : '',
            'as-standing__table-row-head',
          ])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (column) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: column.name,
                    onClick: ($event: any) => (sortData(column.name)),
                    class: _normalizeClass(`as-standing__table-column ${column.class}`),
                    type: "button",
                    ref_for: true,
                    ref: column.name === 'next' ? 'activeItems' : undefined
                  }, [
                    (column.name === 'points1')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createTextVNode(_toDisplayString(column.title) + " ", 1),
                            (sort.value.column === column.name)
                              ? (_openBlock(), _createBlock(IconArrownDown, {
                                  key: 0,
                                  class: _normalizeClass(["as-d-inline-flex", {
                    'as-sort-down': sort.value.type === 'ASC',
                    'as-sort-up': sort.value.type === 'DESC',
                  }])
                                }, null, 8, ["class"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(IconArrowRight, { fill: "#CCC" })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(column.title) + " ", 1),
                          (sort.value.column === column.name)
                            ? (_openBlock(), _createBlock(IconArrownDown, {
                                key: 0,
                                class: _normalizeClass(["as-d-inline-flex", {
                  'as-sort-down': sort.value.type === 'ASC',
                  'as-sort-up': sort.value.type === 'DESC',
                }])
                              }, null, 8, ["class"]))
                            : _createCommentVNode("", true)
                        ]))
                  ], 10, _hoisted_4))
                }), 128))
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows, (row, keyRow) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: keyRow,
                  class: _normalizeClass(["as-standing__table-row", {
            active:
              _ctx.match?.home_team_id === row.team_id ||
              _ctx.match?.away_team_id === row.team_id,
            'as-row__league': _unref(isLeague),
          }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["as-standing__table-column as-standing__table-column-stt as-text-center", {
              'as-stt-popup': _ctx.isPopup,
            }])
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(keyRow + 1), 1)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["as-standing__table-column as-standing__table-column-team", {
              'as-team-popup': _ctx.isPopup,
            }])
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("img", {
                        src: _ctx.getImgUrlBySport('team', row.team_id),
                        class: "as-match__team-logo",
                        alt: row.team_name
                      }, null, 8, _hoisted_10),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(row.team_name), 1)
                    ])
                  ], 2),
                  (_unref(isLeague))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(row.p ?? 0), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(row.won ?? 0), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(row.lost ?? 0), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(row.pct ?? 0), 1),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(getRowdata(row, "strk")), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(getRowdata(row, "game_back")), 1),
                  (!_unref(isLeague))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(row.home ?? "0-0"), 1))
                    : _createCommentVNode("", true),
                  (!_unref(isLeague))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(row.away ?? "0-0"), 1))
                    : _createCommentVNode("", true),
                  (!_unref(isLeague))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(row.division ?? "0-0"), 1))
                    : _createCommentVNode("", true),
                  (!_unref(isLeague))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(row.conference ?? "0-0"), 1))
                    : _createCommentVNode("", true),
                  (!_unref(isLeague))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(row.points_avg ?? "0"), 1))
                    : _createCommentVNode("", true),
                  (!_unref(isLeague))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(row.points_agt ?? "0"), 1))
                    : _createCommentVNode("", true),
                  (!_unref(isLeague))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(row.diff_avg ?? "0"), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getRecent(row), (recent, keyRecent) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: keyRecent,
                          class: _normalizeClass(`as-standing-tag as-standing-tag__${_unref(determineMatchResult)(
                  recent,
                  row.team_id
                ).charAt(0)}`),
                          title: getRecentTitle(recent)
                        }, _toDisplayString(_unref(determineMatchResult)(recent, row.team_id).charAt(0)), 11, _hoisted_27))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("img", {
                      src: getRowdata(row, 'next'),
                      class: "as-match__team-logo",
                      alt: row.team_name
                    }, null, 8, _hoisted_29)
                  ])
                ], 2))
              }), 128))
            ])
          ], 2))
        }), 128)),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"as-note\"><div class=\"as-note-item\"><span class=\"as-key\">W:</span><span class=\"as-value\">Thắng</span></div><div class=\"as-note-item\"><span class=\"as-key\">L:</span><span class=\"as-value\">Thua</span></div><div class=\"as-note-item\"><span class=\"as-key\">PCT:</span><span class=\"as-value\">Thắng</span></div><div class=\"as-note-item\"><span class=\"as-key\">GB:</span><span class=\"as-value\">Thắng chênh lệch</span></div><div class=\"as-note-item\"><span class=\"as-key\">GB</span><span class=\"as-value\">Game Back</span></div><div class=\"as-note-item\"><span class=\"as-key\">STRK:</span><span class=\"as-value\">Các vệt chiến thắng hiện tại</span></div><div class=\"as-note-item\"><span class=\"as-key\">Phong độ:</span><span class=\"as-value\">Các trận gần nhất</span></div></div>", 1))
      ], 2))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})